export const union = <T>(a: Set<T>, b: Set<T>): Set<T> => {
  return new Set([...a, ...b]);
};

export const intersection = <T>(a: Set<T>, b: Set<T>): Set<T> => {
  return new Set([...a].filter((x) => b.has(x)));
};

export const isEqual = <T>(a: Set<T>, b: Set<T>): boolean => {
  return union(a, b).size === intersection(a, b).size;
};

export const difference = <T>(a: Set<T>, b: Set<T>): Set<T> => {
  return new Set([...a].filter((x) => !b.has(x)));
};

export const differenceFromArray = <T>(
  a?: Array<T>,
  b?: Array<T>,
): Array<T> => {
  const setA = new Set(a);
  const setB = new Set(b);
  return [...difference(setA, setB)];
};
